import http from './http'

export function getOverview() {
  return http.get('/analytics/overview')
}

export function listPostAnalytics() {
  return http.get('/analytics/posts')
}

export function getPostAnalytics(id) {
  return http.get(`/analytics/posts/${id}`)
}

export function syncAnalytics() {
  return http.post('/analytics/sync')
}
